import Banner from "../CommonComponents/Banner";
import ContactForm from "../CommonComponents/ContactForm";
import FaqSection from "../Components/FaqSection";
import NewsSection from "../Components/NewsSection";
import PresenceSection from "../Components/PresenceSection";
import TnsReady from "../Components/TnsReady";

function Resources() {
  return (
    <>
      <Banner
        backgroundImage="/assets/resource-banner.png"
        label="Empowering Africa"
        heading={
          <>
            Tools & Insights to Help Your
          </>
        }
        heading2="Agency Grow"
        text={
          <>
            Everything you need beyond the booking screen — training, market insight, and support built specifically for African travel agents.
          </>
        }

        // buttons={[
        //     { text: "Explore Solutions", variant: "primary", onClick: () => alert("Explore clicked") }
        // ]}
      />
   
      <NewsSection />
      <PresenceSection />
      <FaqSection />
      <ContactForm />
      <TnsReady />
    </>
  );
}

export default Resources;
